
































import { Component, Watch } from 'vue-property-decorator'
import { ProductMigrationModule } from '@/store/Products/ProductMigrationModule';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import ProductMigrationState from '@/components/Products/ProductMigrations/ProductMigrationState.vue';
import ProductMigration from '@/models/Products/ProductMigrations/ProductMigration';
import ProductMigrationCreateDialog from '@/components/Products/ProductMigrations/ProductMigrationCreateDialog.vue';

@Component({ name: 'ProductMigrationsList', components: { Alert, ProductMigrationState, ProductMigrationCreateDialog }, metaInfo: { title: 'Product Migrations' } })
export default class extends SaascadaVue {

    headers = [
        { text: this.$t('pageText.productMigrations.fields.name'), sortable: false, width: "30%" },
        { text: this.$t('pageText.productMigrations.fields.createdBy'), sortable: false, width: "15%" },
        { text: this.$t('pageText.productMigrations.fields.createdAt'), sortable: false, width: "15%" },
        { text: this.$t('pageText.productMigrations.fields.migrationDate'), sortable: false, width: "15%" },
        { text: this.$t('pageText.productMigrations.fields.failed'), sortable: false, width: "10%" },
        { text: this.$t('pageText.productMigrations.fields.status'), sortable: false, width: "15%" }
    ];
    productMigrationsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.productMigrationsPage = +page;
        }
    }

    async beforeMount() {
        await ProductMigrationModule.getProductMigrations(this.productMigrationsPage);
    }

    get productMigrations() {
        return ProductMigrationModule.productMigrations;
    }

    get totalProductMigrationsPages() {
        return ProductMigrationModule.totalProductMigrationsPages;
    }

    get loading() {
        return ProductMigrationModule.loading;
    }

    get pageSize() {
        return ProductMigrationModule.pageSize;
    }

    @Watch('productMigrationsPage')
    async onProductMigrationsPageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.productMigrationsPage}` } });
        // Get new product migrations
        await ProductMigrationModule.getProductMigrations(this.productMigrationsPage);
    }

    async navigateToProductMigration(productMigration: ProductMigration) {
        this.$router.push({ name: PageNames.ProductMigration, params: { id: productMigration.id }, query: { tab: "0" } });
    }

}
